export enum StorageKey {
  AGENCY_INFO = 'agencyInfo',
  USER_INFO = 'userInfo',
}
